var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcFooterMy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 34 34"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17 17.172c-4.782 0-8.75 3.495-9.484 8.071-.13.811.538 1.535 1.36 1.535h16.247c.823 0 1.49-.724 1.36-1.535-.734-4.576-4.7-8.071-9.483-8.071M20.881 10.881a3.882 3.882 0 1 1-7.764 0 3.882 3.882 0 0 1 7.764 0"
}))));
export default SvgIcFooterMy;